'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _textEllipsis = require('text-ellipsis');

var _textEllipsis2 = _interopRequireDefault(_textEllipsis);

var _helpers = require('helpers');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SliderProductItem: {
        displayName: 'SliderProductItem'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/GoodsSlider/default/SliderProductItem.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
} /**
   * Created by maximus on 10.01.17.
   */

var SliderProductItem = _wrapComponent('SliderProductItem')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        currency: state.currency
    };
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(SliderProductItem, _Component);

    function SliderProductItem() {
        (0, _classCallCheck3.default)(this, SliderProductItem);
        return (0, _possibleConstructorReturn3.default)(this, (SliderProductItem.__proto__ || (0, _getPrototypeOf2.default)(SliderProductItem)).apply(this, arguments));
    }

    (0, _createClass3.default)(SliderProductItem, [{
        key: 'getRemainder',
        value: function getRemainder(nestedOffer, quantityParent, product_detail) {
            var _this2 = this;

            if (nestedOffer.childOffer === null) {
                return null;
            }
            if (nestedOffer.quantity > 0) {
                var quantity = void 0;
                var quantityTechCard = void 0;
                quantity = nestedOffer.quantity;
                if (nestedOffer.childOffer.modifier_option_id !== null && nestedOffer.childOffer.modOption === null) {
                    nestedOffer.childOffer.modOption = nestedOffer.childOffer.modifiedOption.reduce(function (mod, modifier) {
                        if (modifier.id === nestedOffer.childOffer.modifier_option_id) {
                            return modifier;
                        }
                        return mod;
                    }, null);
                }
                if (nestedOffer.childOffer.modOption !== null && nestedOffer.childOffer.type_id !== 5) {
                    nestedOffer.childOffer.unit = nestedOffer.childOffer.modOption.unit;
                    if (nestedOffer.childOffer.modOption.storable === true && nestedOffer.childOffer.modOption.storage_strict) {
                        product_detail.storable = true;
                        if (nestedOffer.childOffer.modOption.remainder.length === 0) {
                            product_detail.remainder = [{ quantity: 0 }];
                        } else if (nestedOffer.childOffer.modOption.remainder[0].quantity > 0) {
                            if ((nestedOffer.childOffer.modOption.unit_id === 2 || nestedOffer.childOffer.modOption.unit_id === 8) && nestedOffer.childOffer.modOption.weight && nestedOffer.childOffer.modOption.weight > 0) {
                                quantity = nestedOffer.childOffer.modOption.weight * nestedOffer.quantity;
                            }
                            quantity = quantity * quantityParent;
                            quantityTechCard = Math.floor(nestedOffer.childOffer.modOption.remainder[0].quantity / quantity);
                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
                                product_detail.remainder = [{ quantity: quantityTechCard }];
                            }
                        } else {
                            product_detail.remainder = [{ quantity: 0 }];
                        }
                    }
                }
                if (nestedOffer.childOffer.modOption === null && nestedOffer.childOffer.type_id !== 5) {
                    if (nestedOffer.childOffer.storable === true && nestedOffer.childOffer.storage_strict) {
                        product_detail.storable = true;
                        if (nestedOffer.childOffer.remainder.length === 0) {
                            product_detail.remainder = [{ quantity: 0 }];
                        } else if (nestedOffer.childOffer.remainder[0].quantity > 0) {
                            if ((nestedOffer.childOffer.unit_id === 2 || nestedOffer.childOffer.unit_id === 8) && nestedOffer.childOffer.weight && nestedOffer.childOffer.weight > 0) {
                                quantity = nestedOffer.childOffer.weight * nestedOffer.quantity;
                            }
                            quantity = quantity * quantityParent;
                            quantityTechCard = Math.floor(nestedOffer.childOffer.remainder[0].quantity / quantity);
                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
                                product_detail.remainder = [{ quantity: quantityTechCard }];
                            }
                        } else {
                            product_detail.remainder = [{ quantity: 0 }];
                        }
                    }
                }
                if (nestedOffer.childOffer.type_id === 5) {
                    nestedOffer.childOffer.remainder = [];
                    nestedOffer.childOffer.storable = false;
                    quantity = nestedOffer.quantity * quantityParent;
                    nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
                        _this2.getRemainder(nestedOfferTwo, quantity, product_detail);
                    });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                product = _props.product,
                orderInOneClick = _props.orderInOneClick,
                currency = _props.currency;
            var _props$product = this.props.product,
                id = _props$product.id,
                price = _props$product.price,
                name = _props$product.name,
                pictures = _props$product.pictures;

            price = parseFloat(price);
            var imgSrc = (0, _helpers.checkPicture)(pictures);
            var withSlider = { height: '465px', marginBottom: '20px' };
            var cartButtonClassName = 'add-cart-button';
            if (this.props.orderInOneClick || this.props.buyInCreditActive) {
                withSlider = { height: '465px', marginBottom: '20px' };
            }
            if (this.props.orderInOneClick && this.props.buyInCreditActive) {
                withSlider = { height: '465px', marginBottom: '80px' };
                cartButtonClassName = 'add-cart-button-three';
            }
            if (product.type_id === 5) {
                product.storable = false;
                product.storage_strict = true;
                product.remainder = [];
                var quantityTechCard = 1;
                var priceComponent = 0;
                var modifierComponent = null;
                var modifierComponentTwo = null;
                var storableComponent = false;
                product.is_quantity_change = false;
                product.nestedOffers.forEach(function (nestedOffer) {
                    if (nestedOffer.quantity > 0 && nestedOffer.childOffer) {
                        modifierComponent = null;
                        if (nestedOffer.childOffer.type_id === 5) {
                            nestedOffer.childOffer.remainder = [];
                            nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
                                _this3.getRemainder(nestedOfferTwo, nestedOffer.quantity, product);
                            });
                        } else {
                            _this3.getRemainder(nestedOffer, quantityTechCard, product);
                        }
                    }
                    if (nestedOffer.is_quantity_change) {
                        product.is_quantity_change = true;
                    }
                });
                price = parseFloat(product.price);
                if (product.modifier_option_id !== undefined) {
                    product.modifier_option.storable = product.storable;
                    product.modifier_option.remainder[0] = product.remainder[0];
                }
            }

            return _react3.default.createElement(
                'div',
                { className: 'product-item-holder hover', style: withSlider },
                _react3.default.createElement(
                    'div',
                    { className: 'product-item flying-to-cart-holder' },
                    _react3.default.createElement(_components2.ProductWishIcon, { product: product, inCard: true }),
                    _react3.default.createElement(
                        'div',
                        { className: 'image' },
                        _react3.default.createElement(
                            _reactRouter.Link,
                            { to: '/product/' + id },
                            _react3.default.createElement('img', { className: ' flying-to-cart-img', alt: '', src: imgSrc })
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'body' },
                        _react3.default.createElement('div', { className: 'label-discount clear' }),
                        _react3.default.createElement(
                            'div',
                            { className: 'title text-center' },
                            _react3.default.createElement(
                                _reactRouter.Link,
                                { to: '/product/' + id },
                                _react3.default.createElement(
                                    'span',
                                    { className: 'visible-lg text-theme-color' },
                                    (0, _textEllipsis2.default)(name, 160, { ellipsis: '...' })
                                ),
                                _react3.default.createElement(
                                    'span',
                                    { className: 'hidden-lg hidden-xs text-theme-color' },
                                    (0, _textEllipsis2.default)(name, 80, { ellipsis: '...' })
                                ),
                                _react3.default.createElement(
                                    'span',
                                    { className: 'visible-xs text-theme-color' },
                                    (0, _textEllipsis2.default)(name, 120, { ellipsis: '...' })
                                )
                            )
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'prices' },
                        _react3.default.createElement(
                            'div',
                            { className: 'price-current text-center text-theme-color' },
                            _react3.default.createElement(_components2.MoneyValue, {
                                value: price,
                                icon: currency.icon,
                                iconAfterValue: currency.icon_after_value
                            })
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'hover-area' },
                        _react3.default.createElement(
                            'div',
                            { className: cartButtonClassName },
                            _react3.default.createElement(_components2.AddToBasket, { product: product, updateProducts: this.props.updateProducts })
                        )
                    )
                )
            );
        }
    }]);
    return SliderProductItem;
}(_react2.Component), _class2.propTypes = {
    product: _react2.PropTypes.object,
    updateProducts: _react2.PropTypes.func,
    orderInOneClick: _react2.PropTypes.bool,
    currency: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = SliderProductItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GoodsSlider/default/SliderProductItem.jsx
// module id = 1665
// module chunks = 0